(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dorie-collection-nav"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dorie-collection-nav')) {
    customElements.define(
      'dorie-collection-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('.dcn__track');
          this.prev = this.querySelector('.dcn__arrow--prev');
          this.next = this.querySelector('.dcn__arrow--next');
          if (!this.track) return;

          // Bring the collection being viewed into view without moving the page.
          const current = this.track.querySelector('[aria-current="page"]');
          if (current) {
            const item = current.closest('.dcn__item');
            const offset = item.offsetLeft - (this.track.clientWidth - item.offsetWidth) / 2;
            this.track.scrollLeft = Math.max(0, offset);
          }

          const step = () => Math.max(160, this.track.clientWidth * 0.8);
          this.prev?.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
          this.next?.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));

          this.update = () => {
            const max = this.track.scrollWidth - this.track.clientWidth - 2;
            if (this.prev) this.prev.hidden = this.track.scrollLeft <= 2;
            if (this.next) this.next.hidden = this.track.scrollLeft >= max;
          };
          this.track.addEventListener('scroll', this.update, { passive: true });
          this.resizeObserver = new ResizeObserver(this.update);
          this.resizeObserver.observe(this.track);
          this.update();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
